import { useEffect } from 'react';

export function useAppsflyerSmartScript(): void {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    if (document.getElementById('appsflyer-smart-script')) {
      return;
    }

    const script = document.createElement('script');

    script.id = 'appsflyer-smart-script';
    script.src = 'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const s = document.getElementById('appsflyer-smart-script');

      if (s) {
        s.remove();
      }
    };
  }, []);
}
